// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2b-q";
export var animationRelative = "_2b-p";
export var backdropBlur = "_2b-0";
export var detailLabelCell = "_2b-12";
export var detailTable = "_2b-11";
export var detailValueCell = "_2b-13";
export var docIconBox = "_2b-1d";
export var docIconBoxMd = "_2b-1f";
export var docIconBoxSm = "_2b-1e";
export var docTypeRow = "_2b-16";
export var docTypeRowInner = "_2b-17";
export var dropdownMatchDatePicker = "_2b-3";
export var evidenceCardContent = "_2b-1c";
export var fileUploadSpin = "_2b-j";
export var gorgiasOpenButton = "_2b-15 _2b-d";
export var gorgiasTicketCard = "_2b-14";
export var heroModalFooterButton = "_2b-18";
export var hiddenContainer = "_2b-o";
export var iconPrimary = "_2b-1g";
export var iconSecondary = "_2b-1h";
export var iconTertiary = "_2b-1i";
export var integrationCard = "_2b-1";
export var integrationLogoBox = "_2b-2";
export var mainColumnSticky = "_2b-1b";
export var maxWidthContainer = "_2b-19";
export var modalContentBody = "_2b-a";
export var modalHeaderImage = "_2b-5";
export var modalImageLabel = "_2b-7";
export var modalImageOverlay = "_2b-6";
export var modalImageSubtitle = "_2b-9";
export var modalImageTitle = "_2b-8";
export var modalImageWrapper = "_2b-4";
export var modalStickyFooter = "_2b-b";
export var removeButton = "_2b-e";
export var sidebarColumn = "_2b-1a";
export var spinner = "_2b-i";
export var timelineLine = "_2b-y";
export var timelineLineBlack = "_2b-10 _2b-y";
export var timelineLineGray = "_2b-z _2b-y";
export var timelineLineHeight = "_2b-x";
export var tlDotActivate = "_2b-u";
export var tlDotActivateAnim = "_2b-t";
export var tlDotHide = "_2b-s";
export var tlDotHideAnim = "_2b-r";
export var tlLineActivate = "_2b-w";
export var tlLineActivateAnim = "_2b-v";
export var uploadHint = "_2b-n";
export var uploadIconBox = "_2b-k";
export var uploadLabel = "_2b-m";
export var uploadText = "_2b-l";
export var uploadZone = "_2b-f";
export var uploadZoneCursorDefault = "_2b-h";
export var uploadZoneCursorPointer = "_2b-g";
export var uploadedFileRow = "_2b-c";
export var viewButton = "_2b-d";